import React, { useEffect, useState } from 'react'
import ProductDetails from '../components/ProductDetails'
import ProductsBanner from '../components/ProductsBanner'
import { useStateValue } from '../StateProvider';
import Axios from "axios";
import { Helmet } from "react-helmet";

function ProductDetailContainer() {
  const getLastItem = thePath => thePath.substring(thePath.lastIndexOf('/') + 1)

  const [{ Product }, dispatch] = useStateValue();
  const [Prod, SetProd] = useState('');

  useEffect(() => {
    let product_id = getLastItem(window.location.pathname);
    let formData = new FormData();
    formData.append("search", product_id);
    Axios.post(`https://hutaib.admin.simboz.website/public/api/search`, formData).
      then((res) => {

        dispatch({
          type: "SET_PRODUCT",
          Product: res.data.products[0]
        })

      }).catch((err) => {
        console.log(err);
      })
  }, [])
  console.log('Product => ', Product)
  return (
    <div>

      <Helmet>
        <meta charSet="utf-8" />
        <title>{Product ? (Product.meta_title ? Product.meta_title : Product.title) : ""}</title>
        <meta name="description" content={Product ? (Product.meta_description ? Product.meta_description : Product.product_desc) : ""} data-react-helmet="true" />
        <meta name="robots" content="noindex" />

      </Helmet>

      {/* <ProductsBanner /> */}

      <ProductDetails product={Product ? Product : Prod} />

    </div>
  )
}

export default ProductDetailContainer
